<script>
import Checkbox from '../common/form/checkbox/Checkbox.vue';
import ChildStatusIcon from '../child/contract/ChildStatusIcon.vue';
import DatePicker from '../common/form/picker/DatePicker.vue';
import EmptyData from '../common/EmptyData.vue';
import Highlight from '../common/Highlight.vue';
import IconDelete from '../common/icon/IconDelete.vue';
import IconEdit from '../common/icon/IconEdit.vue';
import IconReset from '../common/icon/IconReset.vue';
import Image from '../common/Image.vue';
import KgrButton from '../common/form/button/KgrButton.vue';
import Loading from '../common/Loading.vue';
import MonthPicker from '../common/form/picker/MonthPicker.vue';
import MoodPicker from '../child/mood-barometer/MoodPicker.vue';
import NumberInput from '../common/form/input/NumberInput.vue';
import PrintButton from '../common/form/button/PrintButton.vue';
import StyleguideComponent from './StyleguideComponent.vue';
import TextInput from '../common/form/input/TextInput.vue';
import TimePicker from '../common/form/picker/TimePicker.vue';
import TimeRangePicker from '../common/form/picker/TimeRangePicker.vue';

export default {
    components: {
        'kgr-styleguide-component': StyleguideComponent,
    },
    data() {
        return {
            categories: [
                {
                    name: 'Button',
                    elements: [
                        { name: 'KgrButton', component: KgrButton },
                        { name: 'PrintButton', component: PrintButton },
                    ],
                },
                {
                    name: 'Form',
                    elements: [
                        { name: 'Checkbox', component: Checkbox },
                        { name: 'TextInput', component: TextInput },
                        { name: 'NumberInput', component: NumberInput },
                    ],
                },
                {
                    name: 'Picker',
                    elements: [
                        { name: 'MonthPicker', component: MonthPicker },
                        { name: 'DatePicker', component: DatePicker },
                        { name: 'TimePicker', component: TimePicker },
                        { name: 'TimeRangePicker', component: TimeRangePicker },
                    ],
                },
                {
                    name: 'Icon',
                    elements: [
                        { name: 'ChildStatusIcon', component: ChildStatusIcon },
                        { name: 'IconEdit', component: IconEdit },
                        { name: 'IconDelete', component: IconDelete },
                        { name: 'IconReset', component: IconReset },
                    ],
                },
                {
                    name: 'Other',
                    elements: [
                        { name: 'EmptyData', component: EmptyData },
                        { name: 'Loading', component: Loading },
                        { name: 'Highlight', component: Highlight },
                        { name: 'MoodPicker', component: MoodPicker },
                        { name: 'Image', component: Image },
                    ],
                },
            ],
        };
    },
    render(createElement) {
        const elements = [];
        this.categories.forEach((category) => {
            elements.push(createElement('h2', { class: 'headline' }, category.name));
            category.elements.forEach((element) => {
                elements.push(createElement(StyleguideComponent, {
                    props: {
                        name: element.name,
                        element: element.component,
                    },
                }));
            });
        });

        return createElement('div', {}, elements);
    },
};
</script>
